import { render, staticRenderFns } from "./BillingAddress.vue?vue&type=template&id=80f299f0&scoped=true"
import script from "./BillingAddress.vue?vue&type=script&lang=js"
export * from "./BillingAddress.vue?vue&type=script&lang=js"
import style0 from "./BillingAddress.vue?vue&type=style&index=0&id=80f299f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f299f0",
  null
  
)

export default component.exports